import Metrics from 'services/metrics';

export const pushPaymentMethodEvent = (
  event,
  paymentMethod,
  contractType = '',
) => {
  Metrics.newEvent({
    event: event.toLowerCase(),
    payment_method: paymentMethod.toLowerCase(),
    ...(contractType !== ''
      ? { contractType: contractType.toLocaleLowerCase() }
      : {}),
  });
};

export const pushPaymentEvent = (event, category, action, label) => {
  Metrics.newEvent({
    event: event.toLowerCase(),
    eventCategory: category.toLowerCase(),
    eventAction: action.toLowerCase(),
    eventLabel: label.toLowerCase(),
  });
};

export const pushPaymentSuccessEvent = (
  family,
  periodicity,
  gateway,
  playerUrl,
  fromPlayer,
  fromFinPlayer,
) => {
  const labelAddon =
    (family === 'clarovideo' &&
      ((periodicity === 'month' && 'mensual') || 'anual')) ||
    family;

  let eventAction = '';

  if (playerUrl) {
    if (family === 'clarovideo') {
      eventAction = 'suscripcion claro video - vcard';
    } else {
      eventAction = 'add on - vcard';
    }
  } else if (fromPlayer) {
    eventAction = 'add on - tv';
  } else if (fromFinPlayer) {
    if (family === 'clarovideo') {
      eventAction = 'suscripcion claro video - fin player';
    } else {
      eventAction = 'add on - fin player';
    }
  } else if (family === 'clarovideo') {
    eventAction = 'suscripcion claro video - registro';
  } else {
    eventAction = 'add on - registro';
  }

  pushPaymentEvent(
    playerUrl ? `${family} exitosa` : 'registro exitoso',
    'suscripcion',
    eventAction,
    `exitoso - ${labelAddon} - ${gateway}`,
  );
};
